<template>
  <ul class="flex-col m-center list-blank login">
    <li>
      <h1>{{ LANG.login.headline }}</h1>
    </li>
    <li>
      <label>{{ LANG.login.form.email_short }}</label>
      <input type="text" class="input" v-model="email" tabindex="1" autofocus />
    </li>
    <li>
      <div class="flex-row justify-space-between">
        <label>{{ LANG.login.form.password_short }}</label>
        <a href="#reset-pw" class="green text-14" @click="$emit('stateChanged', 'reset-pw')">
          {{ LANG.login.button.reset_password }}
        </a>
      </div>
      <input type="password" class="input" v-model="password" @keyup.enter="login" tabindex="1" />
    </li>

    <li class="mt-20 mb-30">
      <button v-if="!loading && !processingRedirect" class="btn btn-primary no-border" @click="login" tabindex="1">
        {{ LANG.login.button.sign_in }}
      </button>
      <div v-else class="loader loader-sm"></div>
    </li>
    <li>
      <label class="bold">{{ LANG.login.recruiter }}</label>
      <br />
      <a :href="LANG.login.create_account_link" class="green">
        {{ LANG.login.create_account }}

      </a>
    </li>
  </ul>
</template>

<script>
import LANG from "../../i18n/loader"
import API from "../../helper/Api"
import Toastr from "toastr2"
import Navigation from "../../helper/Navigation"

const toastr = new Toastr()

export default {
  emits: [
    'stateChanged',
  ],
  data: () => {
    return {
      LANG,
      Navigation,
      loading: false,
      processingRedirect: false,
      email: "",
      password: "",
    }
  },
  methods: {
    login() {
      this.loading = true
      this.email = this.email.trim()

      API.post("auth", "createSession", {
        data: {
          email: this.email,
          password: this.password.trim(),
        },
        success: () => {
          this.processingRedirect = true
          const path = "/";
          // let path = "/dashboard"
          //
          // if (window.location.pathname != "/")
          //   path = window.location.pathname + window.location.search

          Navigation.updateURL(path)
        },
        error: () => {
          toastr.error(LANG.login.callbacks.INVALIDLOGIN)
        },
        complete: () => {
          this.password = ""
          this.loading = false
        },
      })
    },
  },
}
</script>